/**
 * @desc 查询任务信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 任务ID */
  taskId: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPersonalTaskSimpleResponse>> {
  return defHttp.get({
    url: '/wap/personal/searchById',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryPersonalTaskSimpleResponse>> {
  return defHttp.get({
    url: '/mock/wap/personal/searchById',

    params,
  });
}
